exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-page[data-v-14879853]{position:fixed;top:0;left:0;height:100%;width:100vw;z-index:100;background-color:rgba(0,0,0,.5)}.welcome-page>div[data-v-14879853]{position:relative;margin:0 auto;width:80vw;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);border-radius:.266667rem}.welcome-page>div .bg[data-v-14879853]{width:100%}.welcome-page>div .close[data-v-14879853]{position:absolute;top:-.8rem;right:0;width:.666667rem}.welcome-page>div button[data-v-14879853]{position:absolute;bottom:.533333rem;left:5vw;width:70vw;border-radius:.266667rem}", ""]);

// exports
